import { sessionFetch, isInvalidSession } from '../components/sessionTransport';

export async function checkMasterSession() {
  try {
    const response = await sessionFetch('/master/auth/me', { cache: 'no-store' });
    return response.ok ? 'authenticated' : response.status === 401 || response.status === 403 ? 'unauthenticated' : 'unavailable';
  } catch (error) {
    return isInvalidSession(error) ? 'unauthenticated' : 'unavailable';
  }
}
